import AddUser from "../components/AddUser";
import Breadcrumb from "../components/Breadcrumb";

const AddRolePage = () => {
  return (
    <>
        {/* Breadcrumb */}
        <Breadcrumb title="Add User" />

        {/* AddRoleLayer */}
        <AddUser />
    </>
  );
};

export default AddRolePage;
